import { Outlet } from 'react-router-dom';
import { useUIStore } from '../store/uiStore';
import Sidebar from '../components/layout/Sidebar';
import TopBar from '../components/layout/TopBar';
import { cn } from '../lib/utils';

export default function AppLayout() {
  const { sidebarCollapsed, sidebarMobileOpen, closeMobileSidebar } = useUIStore();
  return (
    <div className="min-h-screen flex bg-lum-bg-light">
      {/* Desktop Sidebar */}
      <aside
        className={cn(
          'hidden lg:flex flex-col fixed top-0 left-0 h-full z-30 transition-all duration-300 ease-in-out',
          sidebarCollapsed ? 'w-sidebar-collapsed' : 'w-sidebar'
        )}
      >
        <Sidebar />
      </aside>

      {/* Mobile Sidebar Overlay */}
      {sidebarMobileOpen && (
        <div className="lg:hidden fixed inset-0 z-40">
          <div className="absolute inset-0 bg-navy/60 backdrop-blur-sm" onClick={closeMobileSidebar} />
          <aside className={cn('relative h-full z-50 transition-[width] duration-300', sidebarCollapsed ? 'w-[72px]' : 'w-[min(280px,86vw)]')}>
            <Sidebar onNavigate={closeMobileSidebar} />
          </aside>
        </div>
      )}

      {/* Main content area */}
      <div
        className={cn(
          'flex-1 flex flex-col min-w-0 transition-all duration-300',
          'lg:ml-sidebar',
          sidebarCollapsed && 'lg:ml-sidebar-collapsed'
        )}
      >
        {/* Top bar */}
        <TopBar />

        {/* Page content */}
        <main className="flex-1 min-h-0">
          <div className="p-4 lg:p-6 animate-fade-in">
            <Outlet />
          </div>
        </main>
      </div>

    </div>
  );
}
